const MODULE_NAME = "CURRENT_USER_";
const FETCH_AIS_TOKEN_STARTED = MODULE_NAME + "FETCH_AIS_TOKEN_STARTED";
const FETCH_AIS_TOKEN_COMPLETED = MODULE_NAME + "FETCH_AIS_TOKEN_COMPLETED";

export {
  FETCH_AIS_TOKEN_STARTED,
  FETCH_AIS_TOKEN_COMPLETED
};
